<ng-template #confirmModal>
  <div id="confirmPopup" class="card confirmPopup" dir={{direction}}>
    <div id="confirmModalHeader" class="modal-header">
      <div id="confirmModalClose" (click)="dismiss()" class="close-icon">
        <img src="assets/images/popup_close_button.svg" alt="close icon" />
      </div>
    </div>
    <div id="confirmPopupBody" class="modal-body popup-body">
      <h2>{{popupTitle}}<span *ngIf="!isProfileGenerate">?</span></h2>
      <div id="confirmPopupCard" class="card-desc">
        <span *ngIf="!isProfileGenerate">{{popupDesc}}</span>
        <span i18n="@@confirm-dlg.package-last-pushed-update.package-last-pushed-update" *ngIf="isProfileGenerate">This package was last pushed on <strong>{{popupDesc}}</strong>. On devices where the package is not 
          yet downloaded, if you generate this package, an updated package will automatically be downloaded</span>
      </div>
    </div>
    <div id="confirmModalFooter" class="modal-footer card-footer">
      <button type="button" (click)="dismiss()" class="btn btn-outline-primary btn-cancel">
        <span i18n="@@confirm-dlg.footer.cancel">Cancel</span>
      </button>
      <button type="button" class="btn btn-primary btn-confirm" (click)="confirmAction()">
        {{popupAction}}
      </button>
    </div>
  </div>
</ng-template>